import React, { useEffect, useState } from 'react';
import liracrypt from '../../components/Liracrypt/liracrypt';
import InputIdentify from './InputCreater';
import { LoadingOutlined, EditOutlined } from '@ant-design/icons';
import ZenFormInput from './ZenFormInput';
import { useLocation } from 'react-router-dom';
import queryString from "query-string";
import { Button, Tooltip } from 'antd';

const SparkTable = ({
    tableData,
    onCellEdit = () => { },
    height = '100%',
    form,
    layoutPosition,
    builder,
    label,
    api,
    LocalDict = [],
    params
}) => {
    const [SparkTableData, setSparkTableData] = useState();
    const [loading, setLoading] = useState(false);
    const [sparkConfig, setSparkConfig] = useState();

    const { search } = useLocation()
    const urlParams = queryString.parse(search);
    //const LocalDict = [];
    const dtArray = ["datePicker", "rangePicker", "dateTimePicker", "timePicker"];

    useEffect(() => {
        setLoading(true);
        if (tableData) {
            setSparkTableData(tableData.data);
            setSparkConfig({
                ...tableData.config
            })
            setLoading(false);
            return;
        }
        liracrypt.get(api, {...urlParams, ...params })
            .then(response => {
                setSparkTableData(response.data.data);
                setSparkConfig({
                    ...response.data.config
                })
                setLoading(false);
            }).catch(err => {
                console.log(err);
            })
    }, [JSON.stringify(params), JSON.stringify(tableData)]);

    const tableCell = (data, index) => {
        if (dtArray.includes(data["typ"])) {

            LocalDict['lira-spark-' + `${params?.dn}--` + data["data_index"]] = data["format"]
                ? data["format"]
                : "YYYY-MM-DD hh:mm:ss";
            LocalDict['lira-spark-' + `${params?.dn}--` + "data_index_from"] = data["data_index_from"];
            LocalDict['lira-spark-' + `${params?.dn}--` + "data_index_to"] = data["data_index_to"];
        }
        return (
            <td style={{ backgroundColor: data.cellStyle?.backgroundColor }}
                rowSpan={(!data.mergeRow || data.mergeRow === '0') ? undefined : data.mergeRow}
                colSpan={data.mergeCol} key={index} className='spark-table'>
                <ZenFormInput
                    textColor={data.cellStyle?.color}
                    controlHeight={data.controlHeight || (40 * data.mergeRow) || 40}
                    extraData={{ ...params }}
                    layoutPosition={layoutPosition}
                    colSpan={24}
                    rows={data['rows']}
                    form={form}
                    name={'lira-spark-' + `${params?.dn}--` + data["data_index"]}
                    pname={'lira-spark-' + `${params?.dn}--` + (data["p_data_index"] || `p_${data["data_index"]}`)}
                    label={data["label"]}
                    defaultValue={data["default"]}
                    defaultFrom={'lira-spark-' + `${params?.dn}--` + data["defaultFrom"]}
                    defaultTo={'lira-spark-' + `${params?.dn}--` + data["defaultTo"]}
                    typ={data["typ"]}
                    disabled={data["readOnly"]}
                    source={data["source"]}
                    sourceParams={data["sourceParams"]}
                    auxParams={data["auxParams"]}
                    format={data["format"]}
                    errorMessage={data["errorMessage"]}
                    placeHolder={data["placeHolder"]}
                    required={data["required"]}
                    options={data["data"]}
                    from={data["data_index_from"]}
                    to={data["data_index_to"]}
                    url={data["url"]}
                    includeAll={data["includeAll"]}
                    multiSelect={data["multiSelect"]}
                    // searchable={data["isSearchable"]}
                    searchable={true}
                    data={data}
                />
            </td>
        )
    }

    const tableEditableCell = (data, index, rowIndex) => {
        if (dtArray.includes(data["typ"])) {

            LocalDict['lira-spark-' + `${params?.dn}--` + data["data_index"]] = data["format"]
                ? data["format"]
                : "YYYY-MM-DD hh:mm:ss";
            LocalDict['lira-spark-' + `${params?.dn}--` + "data_index_from"] = data["data_index_from"];
            LocalDict['lira-spark-' + `${params?.dn}--` + "data_index_to"] = data["data_index_to"];
        }
        return (
            <td style={{ backgroundColor: data.cellStyle?.backgroundColor }}
                rowSpan={(!data.mergeRow || data.mergeRow === '0') ? undefined : data.mergeRow}
                colSpan={data.mergeCol} key={index} className='spark-table'>
                <div className="zen-preview-control-wrapper">
                    <ZenFormInput
                        textColor={data.cellStyle?.color}
                        controlHeight={(40 * data.mergeRow) || 40}
                        extraData={{ ...params }}
                        layoutPosition={layoutPosition}
                        colSpan={24}
                        form={form}
                        name={'lira-spark-' + `${params?.dn}--` + data["data_index"]}
                        pname={'lira-spark-' + `${params?.dn}--` + (data["p_data_index"] || `p_${data["data_index"]}`)}
                        label={data["label"]}
                        defaultValue={data["default"]}
                        defaultFrom={'lira-spark-' + `${params?.dn}--` + data["defaultFrom"]}
                        defaultTo={'lira-spark-' + `${params?.dn}--` + data["defaultTo"]}
                        typ={data["typ"]}
                        disabled={data["readOnly"]}
                        source={data["source"]}
                        sourceParams={data["sourceParams"]}
                        auxParams={data["auxParams"]}
                        format={data["format"]}
                        errorMessage={data["errorMessage"]}
                        placeHolder={data["placeHolder"]}
                        required={data["required"]}
                        options={data["data"]}
                        from={data["data_index_from"]}
                        to={data["data_index_to"]}
                        url={data["url"]}
                        includeAll={data["includeAll"]}
                        multiSelect={data["multiSelect"]}
                        // searchable={data["isSearchable"]}
                        searchable={true}
                        data={data}
                    />
                    <div className='control-edit-btns footer' style={{ display: 'flex', alignItems: 'center' }}>
                        <Tooltip title="Edit" color="green">
                            <Button
                                style={{ marginRight: 10, color: 'green' }}
                                onClick={() => onCellEdit({
                                    data: {
                                        ...data,
                                        rowIndex,
                                        colIndex: index
                                    },
                                    typ: 'edit-cell'
                                })}
                                type="link"
                                icon={
                                    <EditOutlined style={{ fontSize: 30 }} />
                                }
                            >{''}</Button>
                        </Tooltip>
                    </div>
                </div>

            </td>
        )
    }

    const renderTableCell = (data, index, rowIndex) => {
        if (builder) {
            return tableEditableCell(data, index, rowIndex);
        };
        return tableCell(data, index);
    }

    const renderTableHeader = (x, i) => (
        <th key={i} style={x.style}>{x.title}</th>
    )

    const renderEditableTableHEader = (x, i) => (
        <th key={i} style={x.style}>
            <div className="zen-preview-control-wrapper">
                {x.title}
                <div className='control-edit-btns footer' style={{ display: 'flex', alignItems: 'center' }}>
                    <Tooltip title="Edit" color="green">
                        <Button
                            style={{ marginRight: 10, color: 'green' }}
                            onClick={() => onCellEdit({
                                data: {
                                    ...x,
                                    colIndex: i
                                },
                                typ: 'edit-header'

                            })}
                            type="link"
                            icon={
                                <EditOutlined style={{ fontSize: 30 }} />
                            }
                        >{''}</Button>
                    </Tooltip>
                </div>
            </div>
        </th>
    )

    const renderTblHeader = (x, i) => {
        if (builder) {
            return renderEditableTableHEader(x, i);
        };

        return renderTableHeader(x, i);
    }

    return (
        <div class="spark-table-container" style={{ overflow: 'auto', maxHeight: height }}>
            {
                label ?
                    <div class="ant-form-item-label">
                        <label class="ant-form-item-no-colon" title="Comment">{label}</label>
                    </div> : <></>
            }

            {
                loading ?
                    <LoadingOutlined
                        style={{ fontSize: 80, color: "#dc3545" }}
                        spin
                    /> :
                    <table className='table table-responsive' style={{ width: '100%' }}>
                        {
                            SparkTableData?.headerData ?
                                <thead className='sticky-spark-header'>
                                    {
                                        SparkTableData?.headerData.map(renderTblHeader)
                                    }
                                </thead> : <></>
                        }
                        <tbody>
                            {
                                SparkTableData?.rowData.map((_data, i) => (
                                    <tr key={'row' + i}>
                                        {_data.map((data, index) => renderTableCell(data, index, i))}
                                    </tr>
                                ))}
                        </tbody>
                    </table>}
        </div>
    )
};

export default SparkTable;